var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.$s.featuresContainer},[_c('feature-page',{attrs:{"page-data":_vm.$store.state.pageContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }